import { getCookie } from 'utils/bom-dom-manipulation/cookies';
import { innerWidthThreshold } from 'utils/constants/app/magic-numbers-app';
import { GLOBALS } from 'utils/generic/global-variables';

export const TABLET_BY_DEFAULT_MOBILE = 3;

// Cache the parent check result
const parentCheckCache: { checked: boolean; isMobilePreview: boolean } = {
  checked: false,
  isMobilePreview: false
};

const checkParentForMobilePreview = (): boolean => {
  // Return cached result if already checked

  if (parentCheckCache.checked) {
    return parentCheckCache.isMobilePreview;
  }

  try {
    if (window.parent && window.parent !== window) {
      const iframe = window.parent.document.querySelector(
        '.iframe-container.mobile.show iframe'
      ) as HTMLIFrameElement;

      if (iframe?.src?.includes('?previewMode=true&device=mobile')) {
        parentCheckCache.isMobilePreview = true;

        return true;
      }
    }
  } catch (error) {
    // Cross-origin access blocked - only log once
    /* console.info(
      `${error}Cannot access parent document (cross-origin), using standard detection`
    );*/
  }

  parentCheckCache.isMobilePreview = false;

  return false;
};

export const isMobile = (): boolean => {
  if (typeof window !== 'undefined') {
    if (window.fromNext) {
      // Check parent once and cache the result
      if (checkParentForMobilePreview()) {
        return true;
      }

      // Fallback to standard user agent detection
      const isTablet = /ipad|android(?!.*mobile)|tablet/i.test(
        navigator.userAgent
      );

      const isMobile = /android.+mobile|ip(hone|[oa]d)/i.test(
        navigator.userAgent
      );

      const tabletByDefaultConfig = getCookie('tabletByDefault') || '3';

      const mobileInTabletFromSetting =
        Number(tabletByDefaultConfig) === TABLET_BY_DEFAULT_MOBILE;

      return isTablet ? mobileInTabletFromSetting : isMobile;
    }

    return typeof window.isMobile !== 'undefined'
      ? +window.isTablet === 1
        ? GLOBALS.appConfigs.tabletByDefault === TABLET_BY_DEFAULT_MOBILE
        : +window.isMobile === 1
      : window.innerWidth < innerWidthThreshold.WINDOW_WIDTH_THRESHOLD_1200;
  }

  return false;
};
